import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { colors } from '../../../../../../colorVars';
import { useMouseCoordinates } from './MouseCoordinatesWrapper';
import style from './Labels.module.css';
const VerticalLabels = ({ size, scaleY, fontSize, numberOfTicks, bottomPadding, verticalZoomRef }) => {
  const { coordinates, showCrossHairs } = useMouseCoordinates();
  const [, y] = coordinates;

  const ticks = useMemo(() => {
    if (scaleY !== null) {
      return scaleY.ticks(numberOfTicks).map((value) => ({
        value,
        offset: scaleY(value),
      }));
    } else {
      return null;
    }
  }, [scaleY, size, numberOfTicks]);
  return (
    <svg height={size + bottomPadding} width={40} stroke={colors.white} ref={verticalZoomRef}>
      {ticks !== null &&
        ticks.map(({ value, offset }) => (
          <text x={3} y={offset + 8} style={{ fontSize }} key={value}>
            {value}
          </text>
        ))}
      {scaleY !== null && showCrossHairs ? (
        <g>
          <rect x={3} y={y > size / 2 ? y - 15 : y} width={37} height={15} fill={colors.white} />
          <text
            className={style.text}
            style={{ fontSize }}
            x={3}
            y={y > size / 2 ? y - 4 : y + 11}
            fill={colors.black}
            stroke={colors.black}
            strokeWidth={1}
          >
            {scaleY.invert(y).toFixed(2)}
          </text>
        </g>
      ) : null}
    </svg>
  );
};

VerticalLabels.propTypes = {
  coordinates: PropTypes.array,
  fontSize: PropTypes.string,
  numberOfTicks: PropTypes.number,
  scaleY: PropTypes.func,
  showCrossHairs: PropTypes.any,
  size: PropTypes.any,
  bottomPadding: PropTypes.number,
  verticalZoomRef: PropTypes.object,
};

export default VerticalLabels;
